import React from 'react'
import { useEditor, useReadOnly, ReactEditor } from 'vendor/slate-react'
import { Transforms } from 'vendor/slate'
import styled from 'styled-components'

const CheckListItem = ({ attributes, children, element }) => {
  const editor = useEditor()
  const readOnly = useReadOnly()
  const { checked } = element

  return (
    <ListItemWrapper {...attributes}>
      <CheckBoxWrapper contentEditable={false}>
        <input
          type="checkbox"
          checked={typeof checked !== 'undefined' ? checked : false}
          onChange={event => {
            const path = ReactEditor.findPath(editor, element)
            Transforms.setNodes(editor, { checked: event.target.checked }, { at: path })
          }}
        />
      </CheckBoxWrapper>
      <TextWrapper contentEditable={!readOnly} suppressContentEditableWarning checked={checked}>
        {children}
      </TextWrapper>
    </ListItemWrapper>
  )
}

export default CheckListItem

const ListItemWrapper = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  & + & {
    margin-top: 0;
  }
`

const CheckBoxWrapper = styled.span`
  margin-right: 0.75em;
`

const TextWrapper = styled.span`
  flex: 1;
  opacity: ${props => (props.checked ? 0.666 : 1)};
  text-decoration: ${props => (!props.checked ? 'none' : 'line-through')};
  &:focus {
    outline: none;
  }
`
